<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>岗位薪资</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="backHref">美团大仓</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!isHideDetails && !addHideIs">
      <section class="searchBox">
        <span class="addStyle">
          <a-button type="primary" icon="plus" @click="addHideIs = !addHideIs"
            >增加</a-button
          >
        </span>
        <span>
          <label>项目：</label>
          <a-select
            placeholder="请选择项目"
            v-model="project_id"
            showSearch
            :filterOption="filterOption"
            style="min-width: 200px; margin-right: 20px"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in projectList"
              :key="i"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>结算月：</label>
          <a-month-picker v-model="monthVal" @change="selectMonth" />
        </span>
        <span>
          <label>字符串：</label>
          <a>
            <a-input placeholder="姓名|手机号|身份证号" v-model="query_field" />
          </a>
        </span>
        <span>
          <a-button style="margin-right: 10px" @click="clearSearch"
            >重置</a-button
          >
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="(item, j) in thList" :key="j">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.length < 1">
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.project_name }}</td>
              <td>{{ item.month_date.substring(0, 7) }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.phone }}</td>
              <td>
                {{ item.amount == "" ? "" : Number(item.amount) + "元" }}
              </td>
              <td>
                <a @click="detailsPage(item)">详情</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- content end -->
    <!-- 批量导入 -->
    <addDCForm v-show="addHideIs" v-on:hideInAdd="hideInAdd" />
    <!-- 批量导入 end -->
    <!-- 详情 -->
    <DCDetails v-show="isHideDetails" :detailsVal="detailsVal" />
    <!-- 详情 end -->
  </div>
</template>
<script>
import axios from "axios";
import addDCForm from "@/components/manpower/addDCForm";
import DCDetails from "@/components/manpower/DCDetails"; //详情
export default {
  data() {
    return {
      data: [],
      loading: false,
      page: 1,
      pagination: {},
      thList: ["项目名称", "月份", "姓名", "手机号", "当月合计收入", "操作"],
      isHideDetails: false,
      details: {},
      query_field: "",
      addHideIs: false,
      detailsVal: {},
      project_id: "",
      projectList: [],
      monthVal: null,
      start_date: "",
      end_date: ""
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  components: {
    addDCForm,
    DCDetails
  },
  mounted() {
    this.getData(); //获取列表
    this.getPro(); //获取项目
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    selectMonth(date, dateString) {
      this.start_date = dateString;
      this.end_date = dateString;
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          trade_id: 5,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.projectList = res.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
        });
    },
    detailsPage(item) {
      this.detailsVal = item;
      this.isHideDetails = true;
    },
    backHref() {
      this.isHideDetails = false;
      this.addHideIs = false;
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    onSearch() {
      this.page = 1;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    clearSearch() {
      this.query_field = "";
      this.project_id = "";
      this.monthVal = null;
      this.start_date = "";
      this.end_date = "";
      this.page = 1;
      this.getData();
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      let url =
        this.httpsBasic.url +
        this.httpsBasic.people +
        "Storehouse_month_salary/monthSalaryList";
      let params = {
        current_page: this.page,
        per_page: 10,
        query_field: this.query_field,
        start_date: this.start_date,
        end_date: this.end_date,
        project_id: this.project_id,
        token: window.localStorage.getItem("xnwfPcToken")
      };
      // console.log(params)
      axios
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            // console.log(res.data.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    hideInAdd() {
      this.addHideIs = false;
      this.reload();
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.searchStyle {
  > input {
    margin: 0 20px;
    width: 200px;
  }
}
.listContainer {
  .searchBox {
    display: block;
    > span {
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 10px;
      label,
      a {
        display: inline-block;
      }
    }
  }
}
</style>
